import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useComputeDefaultState} from '../PriceAndBrand/utils';
import {usePriceAndBrandSection} from '../useGetProductBulkSection';
import {BrandAndProductNameQuickViewLoading} from './BrandAndProductNameQuickViewLoading';
import {
  BrandAndProductNameQuickViewProps,
  BrandAndProductNameQuickViewView,
} from './BrandAndProductNameQuickViewView';

export const BrandAndProductNameQuickView: React.FC<
  BrandAndProductNameQuickViewProps
> = props => {
  const defaultState = useComputeDefaultState();

  return (
    <DataFetcher
      request={usePriceAndBrandSection()}
      Error={null}
      Loading={() => (
        <BrandAndProductNameQuickViewLoading className={props.className} />
      )}
      viewProps={props}
      View={BrandAndProductNameQuickViewView}
      computeDefaultState={() => defaultState}
    />
  );
};
